module.exports = __webpack_public_path__ + "static/media/profile.a432180e.png";